'use client';

import { FocusSplit } from '../components/FocusSplit/FocusSplit';
import { HeartRate } from '../components/HeartRate/HeartRate';
import { NowStatus } from '../components/NowStatus/NowStatus';
import { StatCards } from '../components/StatCards/StatCards';
import styles from './LifeCharts.module.css';

export const LifeCharts = () => (
  <main className={styles.page}>
    <NowStatus />

    <section className={styles.section}>
      <h2 className={styles.label}>This week</h2>
      <StatCards />
    </section>

    <section className={styles.section}>
      <h2 className={styles.label}>Where the week goes</h2>
      <FocusSplit />
    </section>

    <section className={styles.section}>
      <h2 className={styles.label}>Heart rate</h2>
      <HeartRate />
    </section>
  </main>
);
